<template>
  <div>
    <prime-salud-medical-assistance></prime-salud-medical-assistance>
  </div>
</template>

<script>
import es from '@/lang/es/public/views/primesalud-medical-assistance.json'
import en from '@/lang/en/public/views/primesalud-medical-assistance.json'
import LangSelector from '@/components/base/LangSelector.vue'
import { BNavbar, BNavbarBrand, BNavbarNav } from 'bootstrap-vue'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import PrimeSaludMedicalAssistance from '@/components/public/landing/PrimeSaludMedicalAssistance'
import 'vuetify/dist/vuetify.min.css'

export default {
  components: {
    LangSelector,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    PrimeSaludMedicalAssistance,
    NeuCardsSlider
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  data () {
    return { }
  },
  mounted () {
    /* let gtagScript = document.createElement('script')
    gtagScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y')
    document.head.appendChild(gtagScript)
    let gtagLocalScript = document.createElement('script')
    gtagLocalScript.setAttribute('src', '/plugins/gtag-primesalud.js')
    document.head.appendChild(gtagLocalScript) */
  }
}
</script>

<style lang="scss">
.nav-mobile{
  @include mobile(){
    padding: 3rem 0rem !important
  }
}
.section {
  @include section;
  min-height: 100vh;
}
.navbar-brand-img-bigger {
  width: 240px;
  @include mobile(){
      width: 169px;
  }
}

@include tablets {
    ul.navbar-nav {
      background-color: transparent !important;
      box-shadow: none !important;
    }
}

// Black section with full column image
.section-invert {
  @include section;
  background-color: $black;

  h3 {
    color: $white;
  }

  .content {
    @include container-padding;

    @include desktop {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }

  }

  .subtitle {
    @include desktop-sm {
      width: 100% !important;
    }

    p {
      color: $gray;
    }

    span {
      color: $gray
    }
    .subtitle-list {
      &.subtitle-list-large {
        p {
          color: $white;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
      &:not(.subtitle-list-large) {
        span {
          color: $white;
        }
      }
      span {
        font-size: 1.25rem;
        display: inline-block;
      }
      > div {
        margin-bottom: 1rem;
        color: $white;
        > span {
          font-size: 1.5rem;
        }
      }

      .v-icon {
        color: $gray;
        margin-right: 1rem;
      }
    }
  }

  .col-bg {
    width: 100%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/views/opensalud/landing/PrimesaludMedicalAssistance.vue